// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bankId: __t.u64().primaryKey().name("bank_id"),
  systemKey: __t.string().name("system_key"),
  bankSov: __t.i64().name("bank_sov"),
  updatedAt: __t.timestamp().name("updated_at"),
});
